import { EventsActivity, ItineraryActivity } from "../models/activity.model";
import { BaseActivityCard } from "./BaseActivityCard";
import { DocumentationList } from "@/components/ui/documentation-list";
import {
  ActivityAddress,
  ActivityDateRange,
  ActivityTimeRange,
  ActivityCost,
  ActivityLink
} from "./ActivityFields";

interface EventsCardProps {
  activity: EventsActivity;
  onEdit: (activity: ItineraryActivity) => void;
  onDelete: (activity: ItineraryActivity) => void;
  onDuplicate?: (activity: ItineraryActivity) => void;
  onSaveToLibrary?: (activity: ItineraryActivity) => void;
  onExpand?: () => void;
  isReadOnly?: boolean;
  onDragStart?: (activity: ItineraryActivity) => void;
  onDropBefore?: (sourceActivityId: string, targetActivityId?: string) => void;
  onDragEnd?: () => void;
  isTraveler?: boolean;
  isAdmin?: boolean;
  unsaved?: boolean;
}

export const EventsCard = ({
  activity,
  onEdit,
  onDelete,
  onDuplicate,
  onSaveToLibrary,
  onExpand,
  isReadOnly = false,
  onDragStart,
  onDropBefore,
  onDragEnd,
  isTraveler = false,
  isAdmin = false,
  unsaved = false,
}: EventsCardProps) => {

  const renderAlwaysVisible = () => (
    <>
      <ActivityAddress address={activity.address} />
      <ActivityDateRange start_date={activity.start_date} end_date={activity.end_date} />
      <ActivityTimeRange start_time={activity.start_time} end_time={activity.end_time} />
      <ActivityCost cost={activity.cost} isAdmin={isAdmin} isTraveler={isTraveler} />
    </>
  );

  const renderCollapsible = () => (
    <>

      {/* Documentation */}
      <DocumentationList documentation={activity.documentation || []} />

      {/* Link */}
      <ActivityLink link={activity.link} isAdmin={isAdmin} isTraveler={isTraveler} />
    </>
  );

  return (
    <BaseActivityCard
      activity={activity}
      onEdit={onEdit}
      onDelete={onDelete}
      onDuplicate={onDuplicate}
      onSaveToLibrary={onSaveToLibrary}
      onDragStart={onDragStart}
      onDropBefore={onDropBefore}
      onDragEnd={onDragEnd}
      onExpand={onExpand}
      isReadOnly={isReadOnly}
      isTraveler={isTraveler}
      isAdmin={isAdmin}
      unsaved={unsaved}
      media={activity.media}
    >
      {{
        alwaysVisible: renderAlwaysVisible(),
        collapsible: renderCollapsible()
      }}
    </BaseActivityCard>
  );
};
